
namespace GeniuzPOS.Product {

    @Serenity.Decorators.registerEditor()
    export class SkuHdEditors extends Serenity.LookupEditorBase<Serenity.LookupEditorOptions, SkuHdRow>{

        constructor(hidden: JQuery) {
            super(hidden);
        }

        protected getLookupKey() {
            return SkuHdRow.lookupKey;
        }

        // protected getItemText(item, lookup) {
        //     return super.getItemText(item, lookup) + ' [' + item.MbFirstName+']';
        // }
    }
}
